import { useCallback, useState } from 'react'

import {
  DropdownListSeparator,
  DropdownMenu,
  DropdownMenuItem,
  DropdownTextItem,
} from '@/components/DropdownMenu'
import { Tooltip } from '@/components/primitives/Tooltip'
import { MapStyle } from '@/icons'

import { Text } from '@/local/components'

import { StyledMenuIconTrigger } from '../../hooks/useStyles'

import { Menu } from './components/Menu'
import { useResetStyles } from './hooks/useResetStyles'
import { useTexts } from './useTexts'

export function GlobalStyles() {
  const [open, setOpen] = useState(false)

  const resetStyles = useResetStyles()
  const texts = useTexts()

  const onReset = useCallback(() => {
    resetStyles()
    setOpen(false)
  }, [resetStyles, setOpen])

  return (
    <DropdownMenu
      open={open}
      setOpen={setOpen}
      trigger={
        <Tooltip placement="bottom" title={texts.title}>
          <StyledMenuIconTrigger
            menuOpen={open}
            Icon={<MapStyle size={15} color={open ? '$scienceBlue' : '$nightRider'} />}
            testid="map-controls-style-on-map"
          />
        </Tooltip>
      }
    >
      <DropdownTextItem>
        <Text color="$paleSky" size="$h4" uppercase>
          {texts.title}
        </Text>
      </DropdownTextItem>

      <Menu menuOpen={open} />

      <DropdownListSeparator />

      <DropdownMenuItem warn onClick={onReset}>
        {texts.resetAll}
      </DropdownMenuItem>
    </DropdownMenu>
  )
}
